import { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";

import NewHeader from "../components/Header/NewHeader";
import Footer from "../components/Footer/Footer";

const RegistrationForm = () => {
  const [iframeHeight, setIframeHeight] = useState(668);

  const formUrl = useMemo(() => {
    const url = new URL(
      "https://forms.zohopublic.com.au/signetinstituteofaustralia/form/ContactForm/formperma/zohCNb1w-Alj5HFYtkEb7Xd6a30N47vkCTuG9FAD-Yk"
    );

    url.searchParams.set("zf_rszfm", "1");

    // Pass UTM parameters
    const currentParams = new URLSearchParams(window.location.search);

    [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ].forEach((param) => {
      const value = currentParams.get(param);

      if (value) {
        url.searchParams.set(param, value);
      }
    });

    // Pass current page URL as referrer
    const referrer = window.location.href;

    if (referrer) {
      const finalReferrer =
        referrer.length > 1800
          ? window.location.origin + window.location.pathname
          : referrer;

      url.searchParams.set("referrername", finalReferrer);
    }

    return url.toString();
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (!event.data || typeof event.data !== "string") {
        return;
      }

      const data = event.data.split("|");

      if (data.length !== 2 && data.length !== 3) {
        return;
      }

      const formPerma = data[0];
      const newHeight = parseInt(data[1], 10);

      if (
        !formPerma ||
        Number.isNaN(newHeight) ||
        !formPerma.includes(
          "zohCNb1w-Alj5HFYtkEb7Xd6a30N47vkCTuG9FAD-Yk"
        )
      ) {
        return;
      }

      setIframeHeight(newHeight + 15);
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Registration Form - Signet Institute</title>
        <meta
          name="description"
          content="Registration Form - Signet Institute of Australia"
        />
      </Helmet>

      <NewHeader />

      <div
        id="zf_div_zohCNb1w-Alj5HFYtkEb7Xd6a30N47vkCTuG9FAD-Yk"
        style={{
          width: "100%",
          paddingTop: "100px",
          paddingBottom: "50px",
        }}
      >
        <iframe
          id="zoho-registration-form"
          title="Registration Form"
          src={formUrl}
          style={{
            border: "none",
            width: "99%",
            height: `${iframeHeight}px`,
            transition: "all 0.5s ease",
          }}
          frameBorder="0"
          scrolling="no"
          aria-label="Registration Form"
        />
      </div>

      <Footer />
    </>
  );
};

export default RegistrationForm;